import { useParams } from "react-router-dom";
import { HOSTNAME, isExternalUrl } from "@src/utils";
import BottomFixedModal from "../common/bottomFixedModal/BottomFixedModal";
import { WriteReviewBottomModalButton } from "../partner/PartnerBottomButtonsWrap";
import WriteReviewImage from "@src/assets/images/partner/review/write-review-icon.png";
import WriteNaverReviewImage from "@src/assets/images/partner/review/write-naver-review-icon.png";
import "./bottomFloatingButton.scss";
import { DuplicateReservationModal } from "./home/HomeHallCard";
interface Props{
    partnerId:string | number
    hallPayload?: any,
    buttonName:string,
    children?:any,
    isOpenWriteReviewModal?:boolean,
    // isOpenReservationModal?:boolean
    // setOpenReservationModal:(bool)=>void,
    onClose:()=>void,
    handleRightBtnClick:()=>void, //기본 버튼 클릭핸들러
    isDuplicateBooking:boolean, // 상담 중복예약 여부 
    setIsDuplicateBooking:(bool)=>void
}
const BottomFloatingButton = ({
    hallPayload,
    buttonName,
    children,
    isOpenWriteReviewModal,
    onClose, 
    handleRightBtnClick,
    isDuplicateBooking,
    setIsDuplicateBooking
  }:Props) => {
    const partnerUuid = useParams().uuid;
    const writeReviewPageUrl = `h2mwbell://community/review/write?type=${partnerUuid}&name=${hallPayload?.bizName}`
    const writeBlogReviewPageUrl = isExternalUrl(`${HOSTNAME}/partner/${partnerUuid}/write-review-blog`)

    function handleClickWriteReviewButton(link?: string) {
        if (link) {
            window.location.href = link;
        }
        onClose()
    }
  
    return (
    <>
        <div className="bottom-buttons-wrap"  style={{display: buttonName === '' ? 'none':''}}>
            <div className="inner">
            {children}
            <button onClick={handleRightBtnClick} className="btn btn-giant btn-red500">
                {buttonName}
            </button>
            </div>
        </div>

        {/* 리뷰쓰기 하단 팝업 */}
        <BottomFixedModal
            isShow={isOpenWriteReviewModal}
            title={"리뷰쓰기"}
            hasCloseButton={false}
            hideModal={onClose}
            className="partner-bottom-write-review-modal">
          <WriteReviewBottomModalButton
            onClick={() => handleClickWriteReviewButton(writeReviewPageUrl)}
            imageUrl={WriteReviewImage}
            title="웨딩북 리뷰 쓰기"
            description="사진을 첨부해서 리뷰를 작성해보세요."
            />
          <WriteReviewBottomModalButton
            onClick={() => handleClickWriteReviewButton(writeBlogReviewPageUrl)}
            imageUrl={WriteNaverReviewImage}
            title="네이버 블로그 리뷰 쓰기"
            description="내 블로그에 작성한 후기 URL을 등록해보세요."
            />
          <DuplicateReservationModal isDuplicate={isDuplicateBooking} setIsDuplicate={setIsDuplicateBooking}/>
        </BottomFixedModal>
    </>
    );
}

export default BottomFloatingButton;